export default __webpack_public_path__ + "static/media/gallery - prince vs clean_05.c10e7934.jpg";